import { IoIosCheckmarkCircleOutline, IoIosWarning } from 'react-icons/io';

import styled, { keyframes } from 'styled-components';

const successFrames = keyframes`
  0%, 100% {
    opacity: 0;
    transform: translateY(80px);
  }

  30%, 50%, 75%, 85% {
    opacity: 1;
    transform: translateY(-16px);
  }
`;

const errorFrames = keyframes`
  0%, 100% {
    opacity: 0;
    transform: translateY(-200px);
  }

  30%, 50%, 75%, 85% {
    opacity: 1;
    transform: translate(0);
  }
`;

export const ToastNeutral: any = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 90%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 20px;
  z-index: 10000;
  border-radius: 16px;
  background: ${({ theme }) => theme.toastComponent.successBackground};
  animation: ${successFrames} 6s ease-in-out;
`;

ToastNeutral.SuccessIcon = styled(IoIosCheckmarkCircleOutline)`
  font-size: 30px;
  flex-shrink: 0;
  color: ${({ theme }) => theme.toastComponent.toastColor} !important;
`;

ToastNeutral.WarningIcon = styled(IoIosWarning)`
  font-size: 30px;
  flex-shrink: 0;
  color: ${({ theme }) => theme.toastComponent.toastColor} !important;
`;

ToastNeutral.Message = styled.span`
  margin-left: 12px;
  padding-top: 10px;
  padding-bottom: 10px;
  word-break: break-word;
  color: ${({ theme }) => theme.toastComponent.toastColor};
`;

ToastNeutral.Button = styled.span`
  font-weight: 600;
  font-size: 16px;
  margin-left: 16px;
  color: ${({ theme }) => theme.toastComponent.toastColor};
  cursor: pointer;
`;

export const ToastError: any = styled.div`
  position: fixed;
  width: 100%;
  min-height: 96px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 64px 16px 32px 16px;
  z-index: 10000;
  animation: ${errorFrames} 6s ease-in-out;
  background-color: ${({ theme }) => theme.toastComponent.dangerBackground};
`;

ToastError.Icon = styled.img`
  width: 32px;
  color: ${({ theme }) => theme.toastComponent.toastColor};
`;

ToastError.Message = styled.span`
  margin-left: 12px;
  margin-right: 32px;
  padding-top: 10px;
  padding-bottom: 10px;
  word-break: break-word;
  color: ${({ theme }) => theme.toastComponent.toastColor};
`;

ToastError.Button = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.toastComponent.toastColor};
  cursor: pointer;
`;
